import { languageContext } from '@src/context/language.context'
import { mixpanelService } from '@src/srv/mixpanel.service'
import { DatoCmsFileField } from '@src/typings/dato-cms-assets'
import type { ReactNode } from 'react'
import { useContext } from 'react'
import { Button } from '../button/Button.component'
import { NcImage } from '../nc-image/NcImage.component'
import styles from './QuizIntro.module.scss'

export interface QuizIntroProps {
  title: string
  subTitle: string
  imageText: string
  image: DatoCmsFileField
  buttonTexts: {
    text: {
      text: string
    }
    goalNumber: {
      goalNumber: number
    }
    icon: Pick<DatoCmsFileField, 'url'>
  }[]
}

function trackClick(val: string): void {
  mixpanelService.track('TestQuizClicked', { value: val })
}

export function QuizIntro({
  title,
  subTitle,
  image,
  buttonTexts,
  imageText,
}: QuizIntroProps): ReactNode {
  const { locale } = useContext(languageContext)
  const urlWithLocale = `${process.env['GATSBY_SIGNUP_URL']}/${locale}`
  return (
    <section className={styles.QuizIntro}>
      <div className={styles.QuizIntro__section}>
        <div className={styles.QuizIntro__imageWrapper}>
          <NcImage className={styles.QuizIntro__image} {...image} />
          <div className={styles.QuizIntro__imageText}>{imageText}</div>
        </div>
        <div className={styles.QuizIntro__content}>
          <p className={styles.QuizIntro__subTitle}>{subTitle}</p>
          <h3 className={styles.QuizIntro__heading}>{title}</h3>
          <div className={styles.QuizIntro__buttons}>
            {buttonTexts.map(({ text: { text }, goalNumber: { goalNumber }, icon: { url } }) => (
              <Button
                key={text}
                theme="whiteBrandPurple"
                onClick={() => trackClick(text)}
                href={`${urlWithLocale}/onboarding/privacy?utm_source_web=signup_quiz_button&fg=${goalNumber}`}
              >
                <span className={styles.QuizIntro__buttons__text}>{text}</span>
                <img
                  src={url}
                  alt=""
                  aria-hidden="true"
                  className={styles.QuizIntro__buttons__icon}
                />
              </Button>
            ))}
          </div>
          <div className={styles.QuizIntro__progressWrapper}>
            <div className={styles.QuizIntro__progress} />
          </div>
        </div>
      </div>
    </section>
  )
}
